import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { setNavigate } from './navigation';

export const NavigatorSetter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};
